import { FaLock } from "react-icons/fa";
import { Link } from "react-router-dom";
import usePageTitle from "../hooks/usePageTitle";

function UnauthorizedPage() {
  usePageTitle("Access Denied | Pargro");

  return (
    <main className="grid min-h-[calc(100vh-74px)] place-items-center bg-[#f4f7fb] px-4 py-10">
      <section className="w-full max-w-[30rem] rounded-[8px] bg-white px-6 py-8 text-center shadow-[0_12px_30px_rgba(15,35,58,0.12)]">
        <FaLock className="mx-auto mb-4 h-8 w-8 text-[#b42318]" aria-hidden="true" />
        <h1 className="mb-3 text-2xl font-bold text-[#111827]">
          Access Denied
        </h1>
        <p className="mb-6 text-base text-[#4b5563]">
          Your current role does not have access to this module.
        </p>
        <Link
          className="inline-flex h-[38px] items-center justify-center rounded-md bg-[#1773f8] px-4 text-sm font-medium text-white no-underline transition hover:bg-[#0d63dc] focus-visible:bg-[#0d63dc]"
          to="/dashboard"
        >
          Back to Dashboard
        </Link>
      </section>
    </main>
  );
}

export default UnauthorizedPage;
